import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaidarshancabs() {



  const cardData =
  {
    keyword: 'Mumbai Darshan Cabs ',
    heading: 'Shambhu Cabs: Mumbai Darshan Cabs',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai Darshan Cabs, providing safe, comfortable, and hassle-free travel for tourists, families, and groups looking to explore the iconic attractions of Mumbai. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable sightseeing experience with well-maintained vehicles and spacious seating. With flexible half-day, full-day, and customized tour options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes Mumbai sightseeing convenient, stress-free, and memorable. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted Mumbai Darshan cab services for travelers seeking comfort, safety, and a seamless city tour experience.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 to commemorate the visit of King George V and Queen Mary, is one of Mumbai’s most iconic landmarks. Located on the waterfront in Colaba, it features grand arches in Indo-Saracenic style, offering panoramic views of the Arabian Sea. The surrounding area is lively with street vendors, boat rides to Elephanta Island, and cultural performances, making it a must-visit for tourists exploring Mumbai’s heritage and coastal beauty."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km long boulevard along the Arabian Sea. Famous for its Art Deco buildings and stunning sunset views, it attracts joggers, families, and tourists. The promenade lights up at night, giving it the appearance of a string of pearls. Marine Drive is perfect for leisurely walks, photography, and experiencing Mumbai’s vibrant coastal life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, formerly Victoria Terminus, is a UNESCO World Heritage Site and one of India’s busiest railway stations. Built in 1887 in Victorian Gothic style with domes, turrets, and intricate stone carvings, it is an architectural marvel. The station symbolizes Mumbai’s colonial past and modern connectivity, serving as both a transportation hub and a tourist attraction admired for its historical and cultural significance."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple, dedicated to Lord Ganesha, is one of Mumbai’s most revered religious sites. Located in Prabhadevi, it attracts thousands of devotees daily who seek blessings and fulfillment of wishes. The temple’s idol, adorned with gold, intricate carvings, and beautiful decorations, creates a spiritual and serene atmosphere. Festivals, especially Ganesh Chaturthi, see grand celebrations, making it a cultural and religious landmark."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island near Mumbai, are UNESCO World Heritage Sites featuring rock-cut sculptures dedicated to Lord Shiva. Dating back to the 5th-8th centuries, the caves showcase intricate carvings such as the Trimurti statue, depicting the Hindu trinity. Visitors reach the island by ferry from the Gateway of India, making it a historical, cultural, and scenic destination combining art, mythology, and maritime beauty."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a mosque and tomb situated on an islet off the coast of Worli, accessible via a narrow causeway. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it attracts pilgrims and tourists from around the world. The white marble structure, set against the Arabian Sea, is especially picturesque during high tide and sunset. It is a symbol of Mumbai’s religious harmony and spiritual heritage."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, meaning 'Thieves Market,' is one of Mumbai’s oldest and largest flea markets, famous for antiques, vintage items, Bollywood memorabilia, and curiosities. The bustling market is a treasure trove for collectors, photographers, and bargain hunters. Strolling through its narrow lanes, visitors experience the vibrant chaos, history, and culture of Mumbai’s trading legacy, making it a must-visit for shoppers seeking unique finds."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its vibrant street food, sunset views, and lively atmosphere. Locals and tourists flock here to enjoy snacks like pav bhaji, bhel puri, and ice cream while walking along the shore. The beach is also home to cultural events, kite flying, and recreational activities, offering a relaxing escape from the bustling city life and a perfect spot for family outings and photography."
  },
  {
    "title": "Mount Mary Church",
    "description": "Mount Mary Basilica, located in Bandra, is a Roman Catholic church renowned for its serene ambiance, beautiful architecture, and annual Bandra Fair. The church attracts pilgrims and tourists alike, offering stunning views of the surrounding hills and sea. Its blend of Gothic and modern architecture, along with the spiritual atmosphere, makes it a must-visit destination for those exploring Mumbai’s religious and cultural heritage."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, located in the northern suburbs of Mumbai, is a lush green sanctuary spanning over 100 square kilometers. It houses diverse flora and fauna, including leopards, deer, and various bird species. The park features the Kanheri Caves, trekking trails, boating, and safari options. It serves as a natural escape from the urban hustle, offering wildlife encounters, historical exploration, and outdoor adventure for families and nature enthusiasts."
  }
],




"services": [
  {
    "name": "Mumbai Sightseeing Cab",
    "description": "Mumbai Sightseeing Cab provides tourists with convenient and comfortable transportation to explore the iconic landmarks of Mumbai. From the Gateway of India to Marine Drive and Haji Ali, the service ensures timely pickups, experienced drivers, and a variety of vehicle options including AC sedans and SUVs. Perfect for families, solo travelers, and corporate groups, the cab offers guided routes and flexible booking for half-day or full-day tours."
  },
  {
    "name": "Mumbai City Tour Taxi",
    "description": "Mumbai City Tour Taxi offers a hassle-free way to explore the city’s cultural, historical, and modern attractions. Professional chauffeurs guide passengers through famous sites like Chhatrapati Shivaji Terminus, Bandra-Worli Sea Link, and Elephanta Caves, ensuring safety and comfort. With options for private tours, family trips, and group sightseeing, travelers can enjoy a fully customizable Mumbai experience."
  },
  {
    "name": "Gateway of India Tour Cab",
    "description": "Gateway of India Tour Cab specializes in providing transport for tourists wishing to visit one of Mumbai's most iconic landmarks. The service includes comfortable, well-maintained vehicles, experienced drivers who can also suggest nearby attractions, and flexible schedules for half-day or full-day excursions. Perfect for photography enthusiasts, families, and couples looking for a memorable visit."
  },
  {
    "name": "Mumbai Full-Day Darshan Cab",
    "description": "Mumbai Full-Day Darshan Cab offers complete day-long tours covering major tourist and spiritual attractions across Mumbai. From temples and churches to historical monuments, passengers enjoy seamless travel with experienced drivers, AC vehicles, and comfortable seating. Ideal for travelers who want to cover multiple sites in a single day without the hassle of navigation or parking."
  },
  {
    "name": "Half Day Mumbai Darshan Taxi",
    "description": "Half Day Mumbai Darshan Taxi caters to tourists or corporate guests who prefer a shorter sightseeing experience. The service covers popular destinations within a few hours, offering timely pickups, safe and clean vehicles, and professional chauffeurs knowledgeable about Mumbai’s history and culture. Ideal for quick city tours or evening sightseeing trips."
  },
  {
    "name": "Best Mumbai Tourist Cab",
    "description": "Best Mumbai Tourist Cab ensures a premium sightseeing experience with comfortable vehicles, skilled drivers, and excellent customer service. The service offers curated routes covering Mumbai’s cultural and historical sites, flexible tour durations, and optional extras like guided commentary or photography stops. Suitable for families, groups, and VIP travelers."
  },
  {
    "name": "AC Cab for Mumbai Darshan",
    "description": "AC Cab for Mumbai Darshan provides a comfortable and climate-controlled environment for exploring the city. This service is ideal for tourists and business travelers who want a relaxed, sweat-free experience while visiting major attractions. The cabs are well-maintained, with courteous drivers and convenient booking options."
  },
  {
    "name": "Family Mumbai Darshan Cab",
    "description": "Family Mumbai Darshan Cab is designed for families seeking a safe, comfortable, and enjoyable sightseeing experience. With spacious vehicles, professional drivers, and flexible itineraries, the service ensures a relaxed tour covering popular landmarks, temples, beaches, and historical sites suitable for all age groups."
  },
  {
    "name": "Mumbai Tourist Places Cab",
    "description": "Mumbai Tourist Places Cab offers structured tours to explore the city’s most visited attractions, including markets, temples, historical monuments, and coastal areas. Passengers benefit from guided navigation, secure vehicles, and a service tailored to both first-time visitors and repeat travelers looking for a unique Mumbai experience."
  },
  {
    "name": "24×7 Mumbai Darshan Taxi",
    "description": "24×7 Mumbai Darshan Taxi ensures round-the-clock availability for sightseeing and city tours. Perfect for travelers arriving at odd hours or wanting to explore the city early in the morning or late at night, the service offers safe, comfortable, and prompt transportation with professional drivers familiar with all major routes."
  },
  {
    "name": "Mumbai Temple Tour Cab",
    "description": "Mumbai Temple Tour Cab provides dedicated transportation for spiritual and religious travelers. Covering major temples across Mumbai, including Siddhivinayak, ISKCON, and Mahalakshmi, the service guarantees timely pickups, well-maintained vehicles, and experienced chauffeurs to ensure a serene and stress-free darshan experience."
  },
  {
    "name": "Private Mumbai Sightseeing Cab",
    "description": "Private Mumbai Sightseeing Cab offers exclusive tours tailored to individual preferences. Travelers can customize the itinerary, choose vehicle types, and enjoy personalized guidance from professional drivers. Ideal for families, couples, and small groups seeking privacy and flexibility during their Mumbai sightseeing journey."
  },
  {
    "name": "Affordable Mumbai Darshan Cab",
    "description": "Affordable Mumbai Darshan Cab delivers budget-friendly sightseeing solutions without compromising on safety, comfort, or convenience. Ideal for students, budget travelers, and small families, the service covers major city attractions with flexible pickup and drop-off options."
  },
  {
    "name": "Chauffeur Mumbai Darshan Cab",
    "description": "Chauffeur Mumbai Darshan Cab provides professional, courteous drivers to guide travelers through Mumbai’s tourist spots. Drivers are knowledgeable about traffic patterns, landmark histories, and best photo spots, ensuring a smooth and informative sightseeing experience with safety and comfort."
  },
  {
    "name": "Premium Mumbai Tour Cab",
    "description": "Premium Mumbai Tour Cab offers luxury vehicles for a high-end sightseeing experience. Equipped with modern amenities, AC comfort, and professional chauffeurs, this service is ideal for VIP travelers, corporate guests, or anyone seeking an elevated tour experience across Mumbai’s key attractions."
  },
  {
    "name": "Mumbai Darshan Package Cab",
    "description": "Mumbai Darshan Package Cab provides pre-designed sightseeing packages covering popular landmarks and cultural hotspots. With options for full-day, half-day, or multi-day tours, the service offers reliable vehicles, experienced drivers, and guided routes for a complete and hassle-free Mumbai experience."
  },
  {
    "name": "Tourist Taxi Mumbai Darshan",
    "description": "Tourist Taxi Mumbai Darshan caters specifically to travelers who wish to explore the city’s tourist and cultural spots conveniently. With flexible booking, safe vehicles, knowledgeable drivers, and competitive pricing, this service ensures a memorable and comfortable Mumbai sightseeing journey."
  }
],

"tableData": [
  ["Mumbai Sightseeing Cab", "Mumbai City Tour Taxi"],
  ["Gateway of India Tour Cab", "Mumbai Full-Day Darshan Cab"],
  ["Half Day Mumbai Darshan Taxi", "Best Mumbai Tourist Cab"],
  ["AC Cab for Mumbai Darshan", "Family Mumbai Darshan Cab"],
  ["Mumbai Tourist Places Cab", "24×7 Mumbai Darshan Taxi"],
  ["Mumbai Temple Tour Cab", "Private Mumbai Sightseeing Cab"],
  ["Affordable Mumbai Darshan Cab", "Chauffeur Mumbai Darshan Cab"],
  ["Premium Mumbai Tour Cab", "Mumbai Darshan Package Cab"],
  ["Tourist Taxi Mumbai Darshan", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai Darshan Cabs with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers convenient Mumbai Darshan cab services, perfect for sightseeing, city tours, and exploring Mumbai’s top attractions in comfort."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs to enjoy a smooth and relaxing sightseeing experience across Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai Attractions",
    "WhyChoosedescription": "Our professional drivers know the best routes and tourist spots in Mumbai, ensuring a seamless and enjoyable Darshan tour."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai Darshan cab experience hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, itinerary planning, and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Sightseeing",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized rental plans tailored for your Mumbai Darshan travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic sightseeing experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making your Mumbai Darshan journey smooth, comfortable, and worry-free."
  }
]



















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide Mumbai Darshan cab services?',
    answer: 'Yes, Shambhu Cabs offers dedicated Mumbai Darshan cab services to help tourists explore all the popular attractions in Mumbai comfortably.',
  },
  {
    question: 'How can I book Mumbai Darshan cabs with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for a hassle-free booking experience.',
  },
  {
    question: 'What types of vehicles are available for Mumbai Darshan cab services?',
    answer: 'Shambhu Cabs offers sedans, SUVs, and premium cars ideal for sightseeing tours, group travel, and family outings in Mumbai.',
  },
  {
    question: 'Are drivers experienced for Mumbai Darshan routes?',
    answer: 'Yes, our drivers are licensed, professional, and well-acquainted with all major Mumbai tourist spots to ensure a smooth sightseeing experience.',
  },
  {
    question: 'Can I choose custom pickup and drop-off points for Mumbai Darshan cabs?',
    answer: 'Absolutely. You can select your preferred pickup location and customize drop-off points according to your sightseeing itinerary.',
  },
  {
    question: 'Is the Mumbai Darshan cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock Mumbai Darshan cab services to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Mumbai Darshan cabs?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict hygiene and safety measures for a safe sightseeing experience.',
  },
  {
    question: 'What payment options are available for Mumbai Darshan cab services?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during Mumbai Darshan trips?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai Darshan journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ravi Patil',
    feedback: 'The Mumbai Darshan cab service by Shambhu Cabs made our sightseeing tour very convenient and enjoyable. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Joshi',
    feedback: 'Excellent Mumbai Darshan experience! The driver was knowledgeable, punctual, and the car was very comfortable.',
    rating: 5,
  },
];



















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Darshan Cabs",
  "image": "https://www.shambhucab.com/assets/images/mumbai-darshan-cabs.jpg",
  "description": "Shambhu Cabs offers premium Mumbai Darshan cabs for sightseeing and city tours. Explore tourist attractions, temples, and iconic landmarks with AC, family, or private cabs. Available 24×7 with affordable packages, full-day or half-day tours, chauffeur-driven service, and premium options for a comfortable Mumbai tour experience.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-darshan-cabs"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai Darshan Cabs | Sightseeing & City Tours | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai Darshan cabs with Shambhu Cabs for sightseeing and city tours. Explore tourist attractions, temples, and landmarks with AC, family, or private cabs. Affordable full-day and half-day packages with 24×7 availability."
  />

  <meta
    name="keywords"
    content="Mumbai Sightseeing Cab, Mumbai City Tour Taxi, Gateway of India Tour Cab, Mumbai Full-Day Darshan Cab, Half Day Mumbai Darshan Taxi, Best Mumbai Tourist Cab, AC Cab for Mumbai Darshan, Family Mumbai Darshan Cab, Mumbai Tourist Places Cab, 24×7 Mumbai Darshan Taxi, Mumbai Temple Tour Cab, Private Mumbai Sightseeing Cab, Affordable Mumbai Darshan Cab, Chauffeur Mumbai Darshan Cab, Premium Mumbai Tour Cab, Mumbai Darshan Package Cab, Tourist Taxi Mumbai Darshan"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/32.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaidarshancabs;